import { Injectable } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class PaginationService {

    private static isInitialized = false;

    private static rangeLabel       : string;
    private static itemsPerPageLabel: string;
    private static firstPageLabel   : string;
    private static lastPageLabel    : string;
    private static previousPageLabel: string;
    private static nextPageLabel    : string;

    constructor(private translateSrv: TranslateService) {
        if (PaginationService.isInitialized)
        {
            return;
        }

        PaginationService.isInitialized = false;

        PaginationService.rangeLabel        = this.translateSrv.instant('pagination.range.shortLabel'       );
        PaginationService.itemsPerPageLabel = this.translateSrv.instant('pagination.itemsPerPage.shortLabel');
        PaginationService.firstPageLabel    = this.translateSrv.instant('pagination.firstPage.shortLabel'   );
        PaginationService.lastPageLabel     = this.translateSrv.instant('pagination.lastPage.shortLabel'    );
        PaginationService.previousPageLabel = this.translateSrv.instant('pagination.previousPage.shortLabel');
        PaginationService.nextPageLabel     = this.translateSrv.instant('pagination.nextPage.shortLabel'    );
    }

    public setText (paginator: MatPaginator): void {
        paginator._intl.getRangeLabel     = this.getRangeLabel                 ;
        paginator._intl.itemsPerPageLabel = PaginationService.itemsPerPageLabel;
        paginator._intl.firstPageLabel    = PaginationService.firstPageLabel   ;
        paginator._intl.lastPageLabel     = PaginationService.lastPageLabel    ;
        paginator._intl.previousPageLabel = PaginationService.previousPageLabel;
        paginator._intl.nextPageLabel     = PaginationService.nextPageLabel    ;
    }

    private getRangeLabel (page: number, pageSize: number, length: number) : string
    {
        const current = length > 0 && pageSize > 0 ?
            (page * pageSize + 1) + ' - ' + Math.min((page + 1) * pageSize, Math.max(length, 0)) : 0;
        const total = Math.max(length, 0);

        return PaginationService.rangeLabel.replace('{current}', '' + current).replace('{total}', '' + total);
    }
}
